<template>
  <n-modal-body width="s">
    <div class="modal-content">
      <NTitleBar
        :class="{ 'has-subtitle': subtitle }"
        v-bind="{ closable, title, titleSuffix, backButton, backButtonLabel, subtitle }"
        @back="$emit('back')"
        @close="$emit('close')"
      />
      <NResizable v-if="!hideContent" class="variable-content">
        <slot></slot>
      </NResizable>
      <n-modal-footer v-if="!hideFooter" v-bind="{ currentPage, numPages }">
        <template #right>
          <slot name="rightFooter"></slot>
        </template>
        <template #left>
          <slot name="leftFooter"></slot>
        </template>
      </n-modal-footer>
    </div>
  </n-modal-body>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import NTitleBar from '../NTitleBar.vue'
import NResizable from '../NResizable.vue'

@Component({
  components: { NTitleBar, NResizable }
})
export default class NSimpleModalBody extends Vue {
  @Prop({ default: false, type: Boolean }) backButton!: boolean
  @Prop({ default: undefined }) backButtonLabel?: string
  @Prop({ default: '' }) title!: string
  @Prop({ default: '' }) titleSuffix?: string
  @Prop({ default: '' }) subtitle?: string
  @Prop({ default: true, type: Boolean }) closable!: boolean
  @Prop({ default: false, type: Boolean }) hideFooter!: boolean
  @Prop({ default: false, type: Boolean }) hideContent!: boolean
  @Prop({ type: Number, default: 0 }) numPages!: number
  @Prop({ type: Number, default: 1 }) currentPage!: number
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles' as *;

.modal-content {
  padding: $notch-space-8x;

  @include mobile {
    padding: 0;
  }
}

.variable-content {
  min-height: $notch-space-10x;
}
</style>
